import { AppRoutes } from "./routes";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "./components/Loader/Spinner/Spinner";
import SpinnerTranslucent from "./components/Loader/Spinner/SpinnerTranslucent";
import { setIsLoading, setIsLoadingTranslucent } from "./store/actions";
import { useEffect } from "react";
import { hideConsoleLogs } from "./helpers/utils";
import GoogleAnalytics from "./components/GoogleAnalytics/GoogleAnalytics";
import ThemeSwitcher from "./components/ThemeSwitcher/ThemeSwitcher";
import { initializeTheme } from "./helpers/globalTheme";
import { useLocation } from "react-router-dom";
import CookieConsentBanner from "./components/CookieConsentBanner/CookieConsentBanner";
import { ProgressProvider } from "./contexts/ProgressContext";
import { NotificationProvider } from "./contexts/NotificationContext"; 
import ProgressWidget from "./components/ProgressWidget/ProgressWidget";
import UploadRefreshWarning from "./components/UploadRefreshWarning/UploadRefreshWarning";
// import TrialAlertBanner from "./modules/notifications/components/alert/TrialAlertBanner";

function App() {
  // Hide console logs in production
  hideConsoleLogs();

  const isLoading = useSelector((state: any) => state.spinner.isLoading);
  const isLoadingTranslucent = useSelector(
    (state: any) => state.spinnerTranslucent.isLoading
  );
  const location = useLocation();

  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoading) {
      if (isLoadingTranslucent) {
        dispatch(setIsLoadingTranslucent(false));
        dispatch(setIsLoading(true));
      }
    }
    if (isLoadingTranslucent) {
      if (isLoading) {
        dispatch(setIsLoadingTranslucent(true));
        dispatch(setIsLoading(false));
      }
    }
  }, [isLoading, isLoadingTranslucent]);

  useEffect(() => {
    const timer = setTimeout(() => {
      initializeTheme();
    }, 0);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  useEffect(() => {
    const timer = setTimeout(() => {
      initializeTheme();
    }, 100);

    return () => clearTimeout(timer);
  }, []);


 // const isAuthPage = location.pathname.includes("/auth/") || location.pathname === "/app/terms-and-conditions";

  return (
    <ProgressProvider>
      <NotificationProvider> 
        <UploadRefreshWarning />
        <div className="App">
          <GoogleAnalytics />
          <Spinner is_loading={isLoading} />
          <SpinnerTranslucent is_loading={isLoadingTranslucent} />
          {/* UNIVERSAL ALERT BANNER */}
          {/* {!isAuthPage && <TrialAlertBanner />} */}
          <ToastContainer />
          <ThemeSwitcher />
          <AppRoutes />
          <ProgressWidget />
          <CookieConsentBanner />
        </div>
      </NotificationProvider> 
    </ProgressProvider>
  );
}

export default App;